<app-dialog-base [showLoadingSpinner]="uiState == uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Add Charities</span>
  <ng-container dialog-content>
    @if (uiState === uiStateEnumForTemplate.ShowData) {
    <form
      [formGroup]="createCharityForm">
      <p>Choose the category you would like to add charities to:</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Charity Category</mat-label>
        <mat-select
          data-testid="add-charity-category-select"
          formControlName="categoryControl">
          <mat-option [value]="null"> ----</mat-option>

          @for (category of charityCategories; track category) {
    <mat-option data-testid="add-charity-category-option"
                [value]="category">
      {{ category.Name }}
    </mat-option>
    }

    </mat-select>

    @if (createCharityForm.controls['categoryControl'].hasError('required')) {
    <mat-error data-testid="charity-category-error">
      category is <span class="bold-text">required</span>
    </mat-error>
    }

    </mat-form-field>

    @if ((charityCategories.length + listOfNewCharities.length) == 0) {
    <small class="red-text">
      Note*: The chosen category currently has no associated charities. The category will not appear in the web
      application until a charity has been linked to it.
    </small>

    }

    @if (!createCharityForm.controls['categoryControl'].valid) {
    <p class="text-end">Can't find your category?
      <button mat-flat-button (click)="openAddNewCategoryDialog()" data-testid="add-new-charity-category-button">
        <span class="text-underline">ADD NEW CATEGORY</span>
      </button>
    </p>
    }

    @if (createCharityForm.controls['categoryControl'].valid) {
    <!--
      #1411: "need a way to inform that during charity setup, and then ability to change it later if needed".
      Applies to every charity in this request, which is the case it was asked for — six Holland College teams
      added together are paid through Holland College. Changed later from the Charity Payees screen.
    -->
    @if (canSeePayees) {
    @if (payeesFailedToLoad) {
    <p class="hint-text" data-testid="add-charity-payee-load-failed-hint">
      Couldn't load this game's central payees, so these charities will be paid directly, each receiving its own
      payouts. If they should be paid through a central payee instead, change it afterwards under Charity Payouts.
    </p>
    } @else if (activePayees.length === 0) {
    <p class="hint-text" data-testid="add-charity-no-payees-hint">
      These charities will be paid directly, each receiving its own payouts. This game has no central payee; one
      can be set up later under Charity Payouts and these charities moved to it.
    </p>
    } @else {
    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>Paid through</mat-label>
      <mat-select
        data-testid="add-charity-payee-select"
        formControlName="charityPayeeIdControl">
        <mat-option value="">Paid directly</mat-option>
        @for (payee of activePayees; track payee.Id) {
        <mat-option data-testid="add-charity-payee-option" [value]="payee.Id">{{ payee.Name }}</mat-option>
        }
      </mat-select>
      <mat-hint data-testid="add-charity-payee-explanation">
        A central payee receives these charities' payouts and passes them on, such as a college paying its teams.
        "Paid directly" pays each charity itself.
      </mat-hint>
    </mat-form-field>
    }
    }

    <p>Enter a charity name and click "Add Charity". Add as many as you need, then click Save.</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Enter a new charity name</mat-label>
      <input
        data-testid="new-charity-name-input"
        formControlName="charityNameControl"
        type="text"
        matInput
        placeholder="enter charity name">

      @if (createCharityForm.controls['charityNameControl'].hasError('notAddedToRequest')) {
      <mat-error
        data-testid="add-request-error">
        make sure you click "Add Charity"
      </mat-error>
      }

    </mat-form-field>
    <button class="float-right"
            mat-raised-button
            data-testid="add-charity-to-request-button"
            [disabled]="createCharityForm.controls.charityNameControl.value === ''" (click)="addToCharityList()">
      <mat-icon>add</mat-icon>
      Add Charity
    </button>
    }

    </form>
    }
    @if (listOfNewCharities.length > 0) {
    <h3>New Charities</h3>
    @for (charity of listOfNewCharities; track charity) {
    <div class="flex-row justify-space-between align-center">
      <div>
        <span class="margin-left-med" data-testid="new-charity-name-from-request">{{ charity.name }}</span>
      </div>
      <button matSuffix
              data-testid="remove-new-charity-name-from-request-button"
              mat-icon-button
              aria-label="remove charity"
              matTooltip="remove charity"
              (click)="removeFromCharityList(charity)">
        <mat-icon [matTooltip]="'click here to remove from list'">remove</mat-icon>
      </button>
    </div>
    }
    }
  </ng-container>
  <ng-container actions>
    <button
      mat-button
      data-testid="save-new-charities-button"
      color="primary"
      [disabled]="uiState == uiStateEnumForTemplate.ShowLoading"
      (click)="submitNewCharities()">Save
    </button>
  </ng-container>
</app-dialog-base>
